<template>
  <v-dialog
    v-model="dialog"
    width="420px">
    <div class="dialog-container">
      <div class="dialog-header flex-sb-center">
        <span>Upload Internal Document</span>
        <i
          class="el-icon-close"
          @click="handleCancel"></i>
      </div>
      <div class="dialog-body">
        <el-form
          ref="form"
          :rules="rules"
          :model="formData">
          <div class="form-item">
            <span>Document Type</span>
            <el-form-item
              ref="type"
              prop="type"
              :rules="rules.select"
            >
              <v-select
                v-model="formData.type"
                :value-key="'type'"
                :is-c-a-r="isCAR"
                :is-company="isCompany"
                :list="renew_ticket_file_type"
                is-renew-type
              >
              </v-select>
            </el-form-item>
          </div>
          <div class="form-item">
            <el-form-item
              ref="file_id"
              prop="file_id"
              :rules="rules.upload">
              <v-upload
                :card="true"
                :fileData="formData.file_pic"
                :otherData="{
                  target: 'file_pic',
                  idKey: 'file_id',
                  nameKey: 'file_pic_path',
                }"
                @delete="handlerDeleteFile"
                @uploadSuccess="handlerUploadSuccess"
              />
            </el-form-item>
          </div>
          <div
            class="form-item">
            <span>Remarks</span>
            <el-form-item
              ref="remark"
              prop="remark"
              :rules="rules.input"
            >
              <v-input
                v-model="formData.remark"
                class="mg-b-15"
                type="textarea"
                :rows="4"
              />
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="dialog-footer">
        <v-button
          gray
          @click="handleCancel">Cancel</v-button>
        <v-button
          green
          @click="onContinue">Upload</v-button>
      </div>
    </div>

  </v-dialog>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {getGlobalOptions} from '@api/common'
import {createRenewalReminder} from '@api/renewal'
import {renewFileTypeName} from '@/utils/renew_type'
export default {
  name: 'upload-internal-doc',
  mixins: [MixinOptions,MixinRules],
  props: {
    classId: {
      type: Number,
      default:14
    },
    customer: {
      type: Object,
      default: () => ({})
    },
    value:{
      type: Boolean,
      default: false
    },
    isCompany: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      dialog: false,
      renew_ticket_file_type:[],
      formData: {
        file_pic:{},
        file_id:'',
        type: '',
        remark: '',
      },
    }
  },
  computed:{
    ticket_id(){
      let {ticket_id} = this.$route.query
      return ticket_id
    },
    isCAR(){
      return this.classId ==79
    },
    renewFileTypeName(){
      let type_name = renewFileTypeName
      if(this.isCompany)
        type_name.id_type_pic_path = 'Certificate of Incorporation/Business Registration Certificate'
      if(this.isCAR)
        type_name.mpf_files = 'Others / Supporting Doc'
      return type_name
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.dialog = val
        if(val){
          this.network().getRenewTicketFileTypeOptions()
        }
      }
    },
  },
  methods: {
    handleDelDoc(){
      // this.$ConfirmBox({
      //   isNewConfirm:true,
      //   width:500,
      //   title:'Create Endorsement Ticket',
      //   confirmBtn:'Confirm',
      //   isGreen:true,
      //   message: 'Are you sure to create a endorsement ticket?'
      // }).then(() => {
      // })
    },
    handlerUploadSuccess({ data, otherData }) {
      const { index = '' } = otherData
      const { name, id } = data
      this.formData.file_pic=data
      this.formData.file_id = id
    },
    handlerDeleteFile({ index }) {
      this.formData.file_pic={}
      this.formData.file_id = ''
    },
    handleCancel() {
      this.$emit('input',false)
    },
    onContinue() {
      this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          this.network().createRenewalReminder()
        }
        else {
          console.log(rules)
        }
      })
    },
    network() {
      return {
        getRenewTicketFileTypeOptions: async () => {
          const { data } = await getGlobalOptions({
            options_name: 'renew_ticket_file_type',
            class_id:this.classId
          })
          let {renew_ticket_file_type} = data||{}
          this.renew_ticket_file_type = renew_ticket_file_type
        },
        createRenewalReminder: async () => {
          let {type} = this.formData||{}
          const { data } = await createRenewalReminder({
            ...this.formData,
            ticket_id:this.ticket_id,
            type_name:this.renewFileTypeName[type]
          })
          this.formData ={
            file_pic:{},
            file_id:'',
            type: '',
            remark: '',
          }
          this.$emit('update')
          this.$emit('input',false)
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog{
  box-sizing: border-box;
  border-radius: 6px;
  font-family: 'inter';
}
.dialog-container {
  .dialog-header {
    padding: 16px;
    background: #F6F8FA;
    border-bottom: 1px solid #E1E4E8;
    border-radius: 6px 6px 0 0;
    span{
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      color: #1B1F23;
      flex: none;
      order: 0;
      align-self: stretch;
      flex-grow: 0;
      /*margin: 10px 0px;*/
    }
  }
  .dialog-body{
    padding: 20px 15px;
    .width-80{
      width: 80px;
    }
    .type-button {
      // margin-right: 20px;
      padding-bottom: 30px;
      border-bottom: 1px solid #D1D5DA;
      margin-bottom: 20px;
      /deep/ .el-radio-group{
        display: flex;
      }
      ::v-deep .el-radio {
        //margin-right: 23px;
        margin-top: 8px;
        width: 50%;
        .el-radio__label {
          display: inline-block;

          padding: 0px 10px;
          height: auto;
          //line-height: 30px;
          font-size: 12px;
          border-radius: 50px;
          border: 1px solid #E1E4E8;
          color: #24292E;
          background: white;
          font-weight: 500;
          letter-spacing: 0;
          line-height: 18px;
          margin-left:8px ;
          margin-right: 23px;
        }
      }
    }
    /deep/ .el-date-editor{
      width: 100% !important;
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;

  }
  .form-item{
    .select-type{
      display: flex;
      justify-content: space-between;
      /deep/.select-pay{
        margin-right: 30px;
        width: 50%;
      }
    }
  }
}
</style>
